import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../../../types/redux/IRootStore";
import { useAppDispatch } from "../../../redux/hooks";
import { ModalType } from "./types/modalType";
import { getReprintLabelsRedux, getReprintPrintersRedux } from "../../../redux/slices/reprint.feature";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";

import ModalReprint2 from "./ModalReprint2";
import ModalPrintHistory2 from "./ModalPrintHistory2";
import ModalRelease2 from "./ModalRelease2";
import ModalDefects2 from "./ModalDefects2";
import ModalDelete2 from "./ModalDelete2";
import ModalScrap2 from "./ModalScrap2";
import ModalConsumptionIssuing from "./ModalConsumptionIssuing";
import ModalConsumptionReturn from "./ModalConsumptionReturn";
import ModalPartPallet2 from "./ModalPartPallet2";
import ModalDefectsError from "./ModalDefectsError";
import Spinner from "../Spinner";

export default function BsModal2({ fade = false }) {
    const [opacityValue, setOpacityValue] = useState(0);
    const transitionTimeMs = fade ? 333 : 0;
    const modalPallets2Redux = useSelector((state: IRootState) => state.modalPallets2);
    const dispatch = useAppDispatch();
    const aplSettings = AplSettingsSelector();

    useEffect(() => {
        if (modalPallets2Redux.modalShown !== ModalType.None) {
            setOpacityValue(0.5);
        } else {
            setOpacityValue(0);
        }

        if (modalPallets2Redux.modalShown === ModalType.Reprint) {
            dispatch(
                getReprintPrintersRedux({
                    siteId: aplSettings.siteId,
                    departmentId: aplSettings.departmentId,
                    lineId: 0,
                    groupByPrinterId: false,
                    offline: true
                }) as any
            );
            dispatch(getReprintLabelsRedux() as any);
        }

        return () => {
            setOpacityValue(0);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalPallets2Redux.modalShown]);

    const isModalShown = modalPallets2Redux.modalShown !== ModalType.None;
    const modalComponent = getModalComponent(modalPallets2Redux.modalShown, modalPallets2Redux.loading);

    return isModalShown ? (
        <div>
            <div
                className="fade modal-backdrop show"
                style={{ transition: `opacity ${transitionTimeMs}ms ease-in-out`, opacity: fade ? opacityValue : 0.5 }}
            ></div>
            <div role="dialog" aria-modal="true" className="fade modal show" tabIndex={-1} style={{ display: "block" }}>
                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content">{modalComponent}</div>
                </div>
            </div>
        </div>
    ) : null;

    function getModalComponent(modalType: ModalType, loading: boolean) {
        if (loading) return <Spinner visible={true} marginsClass="mt-4 mb-4" />;

        switch (modalType) {
            case ModalType.Defects:
                return (
                    <>
                        <ModalDefects2 />
                        <ModalDefectsError aplError={modalPallets2Redux.error} culture={aplSettings.culture} />
                    </>
                );
            case ModalType.Release:
                return (
                    <>
                        <ModalRelease2 />
                        <ModalDefectsError aplError={modalPallets2Redux.error} culture={aplSettings.culture} />
                    </>
                );
            case ModalType.Delete:
                return (
                    <>
                        <ModalDelete2 />
                        <ModalDefectsError aplError={modalPallets2Redux.error} culture={aplSettings.culture} />
                    </>
                );
            case ModalType.PartPallet:
                return (
                    <>
                        <ModalPartPallet2 />
                        <ModalDefectsError aplError={modalPallets2Redux.error} culture={aplSettings.culture} />
                    </>
                );
            case ModalType.Scrap:
                return (
                    <>
                        <ModalScrap2 />
                        <ModalDefectsError aplError={modalPallets2Redux.error} culture={aplSettings.culture} />
                    </>
                );
            case ModalType.Reprint:
                return (
                    <>
                        <ModalReprint2 />
                        <ModalDefectsError aplError={modalPallets2Redux.error} culture={aplSettings.culture} />
                    </>
                );
            case ModalType.PrintHistory:
                return (
                    <>
                        <ModalPrintHistory2 />
                        <ModalDefectsError aplError={modalPallets2Redux.error} culture={aplSettings.culture} />
                    </>
                );
            case ModalType.ConsumptionIssuing:
                return (
                    <>
                        <ModalConsumptionIssuing />
                        {/* <ModalDefectsError aplError={modalPallets2Redux.error} culture={aplSettings.culture} /> */}
                    </>
                );
            case ModalType.ConsumptionReturn:
                return (
                    <>
                        <ModalConsumptionReturn />
                        <ModalDefectsError aplError={modalPallets2Redux.error} culture={aplSettings.culture} />
                    </>
                );
            default:
                return null;
        }
    }
}
